const ONESIGNAL_APP_ID = "b52827cf-d5ef-4598-a308-98b1d9dc5c38";

declare global {
  interface Window {
    OneSignalDeferred?: Array<(OneSignal: any) => void>;
    OneSignal?: any;
  }
}

let initialized = false;

export function initOneSignal(): void {
  if (initialized) return;

  try {
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async function (OneSignal: any) {
      await OneSignal.init({
        appId: ONESIGNAL_APP_ID,
        allowLocalhostAsSecureOrigin: true,
      });
    });
    initialized = true;
    console.log("[OneSignal] SDK initialized");
  } catch (error) {
    console.error("[OneSignal] Failed to initialize:", error);
  }
}

export function loginOneSignal(userId: number): void {
  try {
    if (window.OneSignal) {
      window.OneSignal.login(String(userId))
        .then(() => console.log(`[OneSignal] Logged in user ${userId}`))
        .catch((err: any) => console.warn("[OneSignal] Login failed:", err));
    } else {
      window.OneSignalDeferred = window.OneSignalDeferred || [];
      window.OneSignalDeferred.push(async function (OneSignal: any) {
        try {
          await OneSignal.login(String(userId));
          console.log(`[OneSignal] Logged in user ${userId} (deferred)`);
        } catch (err) {
          console.warn("[OneSignal] Deferred login failed:", err);
        }
      });
    }
  } catch (error) {
    console.error("[OneSignal] Failed to login:", error);
  }
}

export function logoutOneSignal(): void {
  try {
    if (window.OneSignal) {
      Promise.resolve(window.OneSignal.logout())
        .then(() => console.log("[OneSignal] Logged out"))
        .catch((err: any) => console.warn("[OneSignal] Logout failed:", err));
    }
  } catch (error) {
    console.error("[OneSignal] Failed to logout:", error);
  }
}

export async function promptForPush(): Promise<void> {
  try {
    if (window.OneSignal) {
      await window.OneSignal.Slidedown.promptPush();
    } else {
      window.OneSignalDeferred = window.OneSignalDeferred || [];
      window.OneSignalDeferred.push(async function (OneSignal: any) {
        await OneSignal.Slidedown.promptPush();
      });
    }
  } catch (error) {
    console.error("[OneSignal] Failed to prompt for push:", error);
    throw error;
  }
}
